import { produce } from "immer";
import { useSearchStore } from '../store';
import { COVERAGE_AREA_MAX_COUNT_SELECTIONS } from "../../market-dynamics/helpers/optionsSelector";
import { getLogo } from "../../service/branding";

export const actions = (set, get) => ({
    setListingViewTitle: listingViewTitle => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        const moduleState = state[selectedModule];
        moduleState.listingViewTitle = listingViewTitle;
    }), false, 'setListingViewTitle'),
    setResults: results => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        const moduleState = state[selectedModule];
        moduleState.results = results;
    }), false, 'setResults'),
    setTransactionCoverageResults: results => set(produce(state => {
        state.transactionCoverageResults = results;
    }), false, 'setTransactionCoverageResults'),
    setColumnDefs: columnDefs => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        const moduleState = state[selectedModule];
        moduleState.columnDefs = columnDefs;
    }), false, 'setColumnDefs'),
    setPinnedBottomRowData: pinnedBottomRowData => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        const moduleState = state[selectedModule];
        moduleState.pinnedBottomRowData = pinnedBottomRowData;
    }), false, 'setPinnedBottomRowData'),
    setDownloadModalStatus: (status) =>
        set((state) => ({
          downloadModalStatus: {
            ...state.downloadModalStatus,
            ...status,
          },
        }), false, 'setDownloadModalStatus'),
    setAgentProfileTabIndex: (selectedTabIndex) => {
        set(produce(state => {
            state.agentProfileTabIndex = selectedTabIndex;
        }), false, 'setAgentProfileTabIndex');
    },
    setAgentProfileTimePeriod: (timePeriod) => {
        set(produce(state => {
            state.agentProfileTimePeriod = timePeriod;
        }), false, 'setAgentProfileTimePeriod');
    },
    setAgentProfileExportDetails: (exportDetails) => {
        set(produce(state => {
            state.agentProfileExportDetails = exportDetails;
        }), false, 'setAgentProfileExportDetails');
    },
    setProductionSummary: (summaryDetails) => {
        set(produce(state => {
            state.productionSummary = summaryDetails;
        }), false, 'setProductionSummary');
    },
    setAreasData: areasData => {
        set(produce(state => {
            if (!state.areasData) return;
            state.areasData = areasData.map((area, index) => {
                const checked = index < COVERAGE_AREA_MAX_COUNT_SELECTIONS;
                return ({
                    id: area.areaId,
                    label: area.area,
                    checked,
                    ...area,
                });
            });
        }), false, 'setAreasData');
    },
    handleCheckArea: (areaId, checked) => {
        set(produce(state => {
            state.areasData = state.areasData.map(area => {
                if (area.id === areaId) {
                    return { ...area, checked };
                }
                return area;
            });;
        }), false, 'handleCheckArea');
    },
    setAgentProfileArea: (selectedArea) => {
        set(produce(state => {
            state.agentProfileArea = selectedArea;
        }), false, 'setAgentProfileArea');
    },
    setAgentProfileProductionTableData: (productionTableData) => {
        set(produce(state => {
            state.agentProfileProductionTableData = productionTableData;
        }), false, 'setAgentProfileProductionTableData');
    },
    setAgentProfileInventoryTableData: inventoryTableData => {
        set(produce(state => {
            state.agentProfileInventoryTableData = inventoryTableData;
        }), false, 'setAgentProfileInventoryTableData');
    },
    setLogoSrc: logoSrc =>
        set(produce(state => {
            state.logoSrc = logoSrc;
    }), false, 'setLogoSrc'),
    fetchLogo: async () => {
        const res = await getLogo();
        if (res === 404) {
            set(produce(state => {
                state.logoSrc = undefined;
            }), false, 'setLogoSrc');
        }
        if (res === 404 || res.error || !res.blob) {
            return;
        }
        const blob = await res.blob();
        // Important: Convert blob to base64 data URL for PDF compatibility.
        const reader = new FileReader();
        reader.onloadend = () => {
            set(produce(state => {
                state.logoSrc = reader.result;
            }), false, 'setLogoSrc');
        };
        reader.readAsDataURL(blob);
    },
});
